/**
 * Private Route Guard
 * Protects routes that require authentication
 * Following PROJECT_STRUCTURE_GUIDE.md pattern
 */

import { Navigate } from "react-router-dom";
import { type ReactNode } from "react";
import { useAuthStore } from "../stores/auth.store";

type PrivateRouteProps = {
  children: ReactNode;
};

/**
 * PrivateRoute Component
 * Wraps protected routes and redirects to login if not authenticated
 */
export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated, isInitialized } = useAuthStore();

  // Wait for auth initialization before checking authentication
  if (!isInitialized) {
    return null; // or a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
